import { ISummaryQ4 } from '../../../../../../modules/API/Reports/models/q4'
import { formatReportRange } from '../../shared/helpers/reportRows'
import { ReportDateRange } from '../../shared/types/row'
import { formatFixed, formatNumber } from '../../shared/helpers/formatNumber'
import { Q4SummaryValues } from '../types/row'

const EMPTY_SUMMARY: Q4SummaryValues = {
  dateRange: '',
  revenue: '0.00',
  middlePrice: '0.00',
  amountPallets: '0',
  weight: '0.00',
  amountPack: '0',
}

export const formatQ4Summary = (
  summary: ISummaryQ4 | null,
  range: ReportDateRange | null,
): Q4SummaryValues =>
  summary
    ? {
        dateRange: formatReportRange(range),
        // Same format as the 'פדיון' column.
        revenue: String(formatNumber(summary.Price)),
        middlePrice: summary.MiddlePrice.toFixed(2),
        amountPallets: summary.AmountPallets.toLocaleString(),
        weight: formatFixed(summary.Weight),
        amountPack: summary.AmountPack.toLocaleString(),
      }
    : { ...EMPTY_SUMMARY, dateRange: formatReportRange(range) }
